<template>
	<Modal v-model="isShow" class="live" class-name="vertical-center-modal" :title="$t('menu_my_modifypwd')"
		:mask-closable="false" footer-hide width="500" @on-cancel="hide">
		<div class="real-form">
			<Form :model="openModel" :rules="rules" class="passwordForm" ref="passwordForm">
				<FormItem prop="password">
					<effect-input type="password" :label='$t("oldPassword")'  v-model="openModel.password"></effect-input>
				</FormItem>
				<FormItem prop="newPassword">
					<effect-input type="password" :label='$t("newPassword")'  v-model="openModel.newPassword"></effect-input>
					<img v-if="isCheck" class="passwordImg" src="@/assets/image/passwordTips.png" alt="">
					<div class="passwordTips" >
						{{$t('passwordcheck')}}
					</div>
				</FormItem>
				<FormItem prop="confirmPassword">
					<effect-input type="password" :label='$t("conNewPassword")'  v-model="openModel.confirmPassword"></effect-input>
				</FormItem>
				<FormItem style="text-align:center;margin-bottom:0">
					<Button type="primary" @click="save">{{$t('save')}}</Button>
					<Button type="primary" @click="hide">{{$t('cancel')}}</Button>
				</FormItem>
			</Form>
		</div>
	</Modal>
</template>

<script>
	import EffectInput from '@/components/EffectInput.vue';

	export default {
		name: 'ModifyPassword',
		components: {
			EffectInput
		},
		data() {
			const ps = /^[a-zA-Z]\w{5,17}$/
			const validatePass = (rule, value, callback) => {
			    if (value === '') {
					this.isCheck = false
			        callback(new Error(this.$t('newPasswordPl')));
			    } else if(!ps.test(value)){
					this.isCheck = true
					callback(new Error(this.$t('simplePassword')));
				} else {
					this.isCheck = false
			        callback();
			    }
			};
			const validatePassCheck = (rule, value, callback) => {
			    if (value === '') {
			        callback(new Error(this.$t('conNewPasswordPl')));
			    } else if (value !== this.openModel.newPassword) {
			        callback(new Error(this.$t('twoPasswordCheck')));
			    } else {
			        callback();
			    }
			};
			return {
				isShow: false,
				loading: false,
				openModel: {
					password: '',
					newPassword: '',
					confirmPassword: ''
				},
				rules: {
					password: [{
						required: true,
						message: this.$t('oldPasswordPl')
					}],
					newPassword: [{ validator: validatePass , trigger: 'blur' }],
					confirmPassword: [{ validator: validatePassCheck , trigger: 'blur' }]
				},
				click: true,
				isTips:false,
				isCheck:false
			}

		},
		methods: {
			save() {
				this.$refs['passwordForm'].validate((valid) => {
					if (valid) {
						if (this.click) {
							this.click = false
						} else {
							return false
						}
						this.$axios.post('/api/userinfo/ModifyPassword', {
							password: this.$encrypt(this.openModel.password),
							newPassword: this.$encrypt(this.openModel.newPassword),
							confirmPassword: this.$encrypt(this.openModel.confirmPassword)
						})
						.then(async (res) => {
							let dt = res.data

							this.click = true
							if (dt.status == 1) {
								this.$Message.success(dt.msg)
								this.hide()
							} else {
								this.$Message.error(dt.msg)
							}
						})
						.catch(() => {
							this.click = true
						})
					}
				})
			},
			show() {
				this.isShow = true
			},
			hide() {
				this.$refs['passwordForm'].resetFields()
				this.isShow = false
			}
		}
	}
</script>
<style lang="less">
	.passwordForm{
		.ivu-form-item-error {
			.effectInput{
				border: 1px solid #ed4014!important;
			}
		}
		.passwordTips{
			position:absolute;
			top: -8px;
			right: -24px;
			background: #ffffff;
			box-shadow: 0 0 10px #ede9f9;
			padding: 8px;
			display: none;
			line-height: 20px;
		}
		.passwordImg{
			position:absolute;
			top: 70px;
			right: 0px;
			cursor: pointer;
		}
		.passwordImg:hover + .passwordTips{
			display: block;
		}
	}
</style>
